import React, { useEffect, useState } from "react";
import { chatApi } from "../../lib/api";

// Small red unread-count badge for a specific chat (ride_id / order_id).
export default function ChatUnreadBadge({ chatId }) {
  const [n, setN] = useState(0);
  useEffect(() => {
    let alive = true;
    const load = () =>
      chatApi
        .summary()
        .then((s) => {
          if (!alive) return;
          const c = (s?.chats || []).find((x) => x.chat_id === chatId);
          setN(c?.unread || 0);
        })
        .catch(() => {});
    load();
    const t = setInterval(load, 15000);
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, [chatId]);
  if (!n) return null;
  return (
    <span
      data-testid={`chat-unread-${chatId}`}
      className="ml-1.5 inline-flex min-w-[18px] items-center justify-center rounded-full bg-red-600 px-1.5 text-xs font-bold leading-none text-white"
    >
      {n > 9 ? "9+" : n}
    </span>
  );
}
